import React from 'react';
import { FetchUserMealsConnectorApollo } from '@front-activerse/common-components';
import UserMealsIndexContainer from './UserMealsIndexContainer';

interface IUserMealsIndexPage {
  mealsNavigation: {
    path: string;
    translationKey: string;
  }[];
}

const UserMealsIndexPage: React.FC<IUserMealsIndexPage> = ({ mealsNavigation }) => {
  return (
    <FetchUserMealsConnectorApollo>
      {({ ...userMealsData }) => (
        <UserMealsIndexContainer {...userMealsData} mealsNavigation={mealsNavigation} />
      )}
    </FetchUserMealsConnectorApollo>
  );
};

export default UserMealsIndexPage;
